export const workspaceAppsKeys = {
  all: (workspaceUuid: string) => ["workspace-apps", workspaceUuid] as const,
  effectiveAll: (workspaceUuid: string) => [
    ...workspaceAppsKeys.all(workspaceUuid),
    "effective",
  ] as const,
  effective: (userUuid: string, workspaceUuid: string) => [
    ...workspaceAppsKeys.effectiveAll(workspaceUuid),
    userUuid,
  ] as const,
  layout: (workspaceUuid: string) => [
    ...workspaceAppsKeys.all(workspaceUuid),
    "layout",
  ] as const,
  catalog: (workspaceUuid: string) => [
    ...workspaceAppsKeys.all(workspaceUuid),
    "catalog",
  ] as const,
  presets: (workspaceUuid: string) => [
    ...workspaceAppsKeys.all(workspaceUuid),
    "presets",
  ] as const,
  installations: (workspaceUuid: string) => [
    ...workspaceAppsKeys.all(workspaceUuid),
    "installations",
  ] as const,
};
